import { useMemo, useState, useEffect } from 'react';
import { HomePageReports } from '../../../functions/home_page/home_page_report_functions';
import { getSessionUUID } from '../../lib/AuthToken';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { getInfringements } from '../../../api/tacho';

import { ActivityIndicator } from '../../custom/ActivityIndicator';
import { ProgressTracker } from '../ProgressTracker';


import logger from "../../../utils/logger";

import WeeklyReport from '../report_components/WeeklyReport';
import RouteReports from '../report_components/RouteReports';
import DriverRoutesReport from '../report_components/DriverRoutesReport';
import FireRegisterReport from '../report_components/FireRegisterReport';
import WeeklyStorageReport from '../report_components/SelectWeeklyStorageReport';
import WeeklyStorageReportDisplay from '../report_components/WeeklyStorageReport';
import WarehouseSnapshotReport from '../report_components/WarehouseSnapshotReport';
import PurchaseOrdersReport from '../report_components/PurchaseOrdersReport';
import SelectHolidaysReport from '../report_components/SelectHolidaysReport';
import HolidaysReport from '../report_components/HolidaysReport';
import InboundReport from '../report_components/InboundReport';
import DispatchReport from '../report_components/DispatchReport';
import ActiveVehiclesReport from '../report_components/ActiveVehiclesReport';
import SubcontractedRoutesReport from '../report_components/SubcontractedRoutesReport';
import ClockInOutReport from '../report_components/ClockInOutReport';
import TimeSheetReport from '../report_components/TimeSheetReport';
import AlcoholTestingReport from '../report_components/AlcoholTestingReport';
import TachoInfringementReport from '../report_components/TachoInfringementReport';
import NetworkFreightConsignmentReport from '../report_components/NetworkFreightConsignmentReport';
import VehicleChecksDisplay from '../VehicleCheckDisplay';

import SelectReports from '../report_components/SelectReports';
import SelectRouteReport from '../report_components/SelectRouteReport';
import SelectByRange from '../report_components/SelectByRange';
import SelectByDateRange from '../report_components/SelectByDateRange';
import SelectCustomerSnapShot from '../report_components/SelectCustomerSnapShot';
import SelectTrailerLocation from '../report_components/SelectTrailerLocation';
import TrailerLocationReport from '../report_components/TrailerLocationReport';
import SelectPONumberReport from '../report_components/SelectPONumberReport';
import SelectSingleDate from '../report_components/SelectSingleDate';
import SelectNetworkFreightReport from '../report_components/SelectNetworkFreightReport';
import { searchNetworkFreightByConsignment } from '../../../api/route';
import { fetch_driver_checks } from '../../../api/vehicles';

const DashboardReports = ({ 
    showAlert,
    customers,
    customerDeliveries,
    uniqueCustomers,
    driversList,
    adminList,
    warehouseStaff,
    allTrailers,
    features,
    permissions,
    isDev,
    isRoutingAllowed,
    isPurchaseOrdersAllowed,
    isTimesheetsAllowed,
    isHolidaysAllowed,
    isAlcoholAllowed,
    isTachoAllowed,
    holidaysFunctions,
    theme,
}) => {

    const reportFunctions = useMemo(() => new HomePageReports(showAlert), [showAlert]);

    const [isLoading, setIsLoading] = useState(false);
    const [isFilesZipDownloading, setIsFilesZipDownloading] = useState(false);
    const [filesZipProgress, setFilesZipProgress] = useState({ current: 0, total: 0, percentage: 0 });
    const [filesZipStatus, setFilesZipStatus] = useState({ message: '', type: 'info' });

   // state to manage report data
    const [showReport, setShowReport] = useState(false);
    const [monthlyReportData, setMonthlyReportData] = useState([]);
    const [snapShotData, setSnapShotData] = useState([]);
    const [reportTableData, setReportTableData] = useState([]);
    const [driverRoutesData, setDriverRoutesData] = useState([]);
    const [fireRegisterReportData, setFireRegisterReportData] = useState([]);
    const [vehicleLeaseReportData, setVehicleLeaseReportData] = useState([]);
    const [weeklyStorageData, setWeeklyStorageData] = useState([]);
    const [purchaseOrdersReportData, setPurchaseOrdersReportData] = useState([]);
    const [holidaysReportData, setHolidaysReportData] = useState({});
    const [allDrivers, setAllDrivers] = useState([]);

    const [inboundReportsData, setInboundReportsData] = useState([]);
    const [dispatchReportsData, setDispatchReportsData] = useState([]);
    const [activeVehiclesData, setActiveVehiclesData] = useState([]);
    const [activeVehiclesReportRequested, setActiveVehiclesReportRequested] = useState(false);
    const [subcontractedRoutesData, setSubcontractedRoutesData] = useState([]);
    const [clockInOutReportData, setClockInOutReportData] = useState([]);
    const [timeSheetReportData, setTimeSheetReportData] = useState([]);
    const [alcoholTestingReportData, setAlcoholTestingReportData] = useState([]);
    const [tachoInfringementReportData, setTachoInfringementReportData] = useState([]);
    const [routesByDateData, setRoutesByDateData] = useState([]);
    const [trailerLocationData, setTrailerLocationData] = useState(null);
    const [networkFreightReportData, setNetworkFreightReportData] = useState(null);
    const [driverVehicleChecksData, setDriverVehicleChecksData] = useState(null);

    const resetReports = () => {
        setShowReport(false);
        setMonthlyReportData([]);
        setReportTableData([]);
        setSnapShotData([]);
        setDriverRoutesData([]);
        setFireRegisterReportData([]);
        setWeeklyStorageData([]);
        setPurchaseOrdersReportData([]);
        setHolidaysReportData({});
        setInboundReportsData([]);
        setDispatchReportsData([]);
        setActiveVehiclesData([]);
        setActiveVehiclesReportRequested(false);
        setSubcontractedRoutesData([]);
        setClockInOutReportData([]);
        setTimeSheetReportData([]);
        setAlcoholTestingReportData([]);
        setTachoInfringementReportData([]);
        setRoutesByDateData([]);
        setTrailerLocationData(null);
        setNetworkFreightReportData(null);
        setDriverVehicleChecksData(null);
    }

    const fetchReports = async (selectedDate) => {
        reportFunctions.fetchReports( selectedDate, setMonthlyReportData, setShowReport, setIsLoading, resetReports );
    };
    
    const fetchRouteReports = async (reportQueryData) => {
        reportFunctions.fetchRouteReports( reportQueryData, setReportTableData, setShowReport, setIsLoading, resetReports );
    }

    const fetchNetworkFreightReport = async (consignmentNumber) => {
        setIsLoading(true);
        resetReports();
        try {
            const { status, data } = await searchNetworkFreightByConsignment(consignmentNumber);
            if (status !== 200) throw new Error(data?.error || 'Unable to search Network Freight jobs');
            setNetworkFreightReportData(data || []);
            setShowReport(true);
        } catch (error) {
            showAlert({
                message: error.message,
                type: 'danger',
                buttons: [{ type: 'danger', label: 'Close' }],
            });
        } finally {
            setIsLoading(false);
        }
    };

    const fetchSnapShot = async (customerData) => {
        reportFunctions.fetchSnapShot( customerData, setSnapShotData, setShowReport, setIsLoading, resetReports );
    };

    const fetchDriverRoutes = async (driverRouteData) => {
        reportFunctions.fetchDriverRoutes( driverRouteData, setDriverRoutesData, setShowReport, setIsLoading, resetReports );
    };

    const fetchDriverVehicleChecks = async ({ selectedValue, startDate, endDate }) => {
        setIsLoading(true);
        resetReports();

        try {
            const { data, status, message } = await fetch_driver_checks(selectedValue, startDate, endDate);
            if (status !== 200) {
                throw new Error(message || 'Unable to fetch vehicle checks');
            }

            setDriverVehicleChecksData(data || []);
            setShowReport(true);
        } catch (error) {
            logger.error('Error fetching driver vehicle checks:', error);
            showAlert({
                message: error.message,
                type: 'danger',
                buttons: [{ type: 'danger', label: 'Close' }],
            });
        } finally {
            setIsLoading(false);
        }
    };

    const fetchRoutesByRange = async (data) => {
        logger.log("Fetching routes for customer with id:", data.selectedValue, "between dates:", data.startDate, "and", data.endDate);
        
        if (!data.selectedValue || !data.startDate || !data.endDate) {
            showAlert({
                message: 'Please select a customer and valid date range.',
                type: 'warning',
                buttons: [{ label: 'Close' }],
            });
            return;
        }

        // Find the customer by ID to get the company name
        const selectedCustomer = customers.find(customer => customer.id == data.selectedValue);
        if (!selectedCustomer || !selectedCustomer.company) {
            showAlert({
                message: 'Selected customer not found or missing company name.',
                type: 'warning',
                buttons: [{ label: 'Close' }],
            });
            return;
        }

        setIsLoading(true);
        setRoutesByDateData([]);

        try {
            const sessionToken = await getSessionUUID();
            
            const response = await fetch('/routing/get_routes_by_date', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionToken}`,
                },
                body: JSON.stringify({
                    customer_company: selectedCustomer.company,
                    start_date: data.startDate,
                    end_date: data.endDate
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseData = await response.json();
            
            if (responseData.error) {
                throw new Error(responseData.error);
            }

            setRoutesByDateData(responseData.routes || []);
            setShowReport(true);
            logger.log(`Fetched ${responseData.total || 0} routes from ${data.startDate} to ${data.endDate}`);
            
            if (responseData.routes && responseData.routes.length > 0) {
                showAlert({
                    message: `Successfully loaded ${responseData.routes.length} routes`,
                    type: 'success',
                    buttons: [{ label: 'Close' }],
                });
            } else {
                showAlert({
                    message: 'No routes found for the selected criteria',
                    type: 'info',
                    buttons: [{ label: 'Close' }],
                });
            }

        } catch (error) {
            logger.error('Error fetching routes by date:', error);
            showAlert({
                message: `Error fetching routes: ${error.message}`,
                type: 'danger',
                buttons: [{ label: 'Close' }],
            });
            setRoutesByDateData([]);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchFireRegisterReport = async (weekData) => {
        reportFunctions.fetchFireRegisterReport( weekData, setFireRegisterReportData, setShowReport, setIsLoading, resetReports );
    };

    const fetchVehicleLeaseReport = async (selectedDate) => {
        reportFunctions.fetchVehicleLeaseReport( selectedDate, setVehicleLeaseReportData, setShowReport, setIsLoading, resetReports );
    };

    const fetchWeeklyStorageReport = async (weekData) => {
        reportFunctions.fetchWeeklyStorageReport( weekData, setWeeklyStorageData, setShowReport, setIsLoading, resetReports );
    };

    // Purchase Orders Report Functions ====================================================================================================
    const fetchPOByNumber = async (poNumber) => {
        reportFunctions.fetchPOByNumber( poNumber, setPurchaseOrdersReportData, setShowReport, setIsLoading, resetReports );
    };

    const fetchPOByDateRange = async (dateRange) => {
        reportFunctions.fetchPOByDateRange( dateRange, setPurchaseOrdersReportData, setShowReport, setIsLoading, resetReports );
    };

    // Inbound Reports Function ===================================================================================================
    const fetchInboundReports = async (dateRange) => {
        reportFunctions.fetchInboundReports( dateRange, setInboundReportsData, setShowReport, setIsLoading, resetReports );
    };

    // Dispatch Reports Function ===================================================================================================
    const fetchDispatchReports = async (dateRange) => {
        reportFunctions.fetchDispatchReports( dateRange, setDispatchReportsData, setShowReport, setIsLoading, resetReports );
    };

    const fetchVehiclesRentalReport = async (dateRange) => {
        setActiveVehiclesReportRequested(true);
        reportFunctions.fetchVehiclesRentalReport( dateRange, setActiveVehiclesData, setShowReport, setIsLoading, resetReports );
    };

    const downloadAllVehiclesAudit = async () => {
        reportFunctions.downloadAllVehiclesAudit(setIsLoading);
    };

    const downloadAllVehiclesFilesZip = async () => {
        setFilesZipProgress({ current: 0, total: 0, percentage: 0 });
        setFilesZipStatus({ message: 'Collecting vehicle file details...', type: 'info' });

        const result = await reportFunctions.downloadAllVehiclesFilesZip(
            setIsFilesZipDownloading,
            (progress) => {
                setFilesZipProgress({
                    current: progress.processed || 0,
                    total: progress.total || 0,
                    percentage: progress.percentage || 0,
                });
                setFilesZipStatus({
                    message: progress.message || 'Preparing vehicle files...',
                    type: 'info',
                });
            }
        );

        if (result?.status === 200) {
            setFilesZipProgress((progress) => ({ ...progress, percentage: 100 }));
            setFilesZipStatus({ message: '', type: 'success' });
        } else {
            setFilesZipStatus({ message: '', type: 'danger' });
        }
    };

    const downloadMissingDocsReport = async () => {
        reportFunctions.downloadMissingDocsReport(setIsLoading);
    };

    // Subcontracted Routes Function ===============================================================================================
    const fetchSubcontractedRoutes = async (dateRange) => {
        try {
            setIsLoading(true);
            resetReports();
            
            const { fetchSubcontractedRoutes } = await import('../../../api/route');
            const { data, status, message } = await fetchSubcontractedRoutes(dateRange.startDate, dateRange.endDate);
            
            if (status === 200) {
                setSubcontractedRoutesData(data || []);
                setShowReport(true);
            } else {
                setSubcontractedRoutesData([]);
                showAlert({
                    message: message || 'Failed to fetch subcontracted routes',
                    type: 'danger',
                    buttons: [{ type: 'danger', label: 'Close' }],
                });
            }
        } catch (error) {
            logger.error("Error fetching subcontracted routes:", error);
            setSubcontractedRoutesData([]);
            showAlert({
                message: 'An error occurred while fetching subcontracted routes',
                type: 'danger',
                buttons: [{ type: 'danger', label: 'Close' }],
            });
        } finally {
            setIsLoading(false);
        }
    };

    // Clock In/Out Report Function =================================================================================================
    const fetchClockInOutReport = async (dateRange) => {
        reportFunctions.fetchClockInOutReport( dateRange, setClockInOutReportData, setShowReport, setIsLoading, resetReports );
    };

    const fetchTimeSheetReport = async (dateData) => {
        reportFunctions.fetchTimeSheetReport( dateData, setTimeSheetReportData, setShowReport, setIsLoading, resetReports );
    };

    const fetchAlcoholTestingReport = async (dateRange) => {
        reportFunctions.fetchAlcoholTestingReport( dateRange, setAlcoholTestingReportData, setShowReport, setIsLoading, resetReports );
    };

    const fetchTachoInfringementReport = async (dateRange) => {
        try {
            setIsLoading(true);
            resetReports();
            
            const result = await getInfringements();
            
            if (result.success && result.infringements) {
                // Filter for signed-off infringements within date range
                const startDate = new Date(dateRange.startDate);
                const endDate = new Date(dateRange.endDate);
                endDate.setHours(23, 59, 59, 999); // End of day
                
                const filteredInfringements = result.infringements.filter(inf => {
                    // Only include signed-off or acknowledged infringements
                    if (inf.status !== 'signed_off' && inf.status !== 'acknowledged') {
                        return false;
                    }
                    
                    const infringementDate = new Date(inf.infringement_date);
                    return infringementDate >= startDate && infringementDate <= endDate;
                });
                
                setTachoInfringementReportData(filteredInfringements);
                setShowReport(true);
            }
        } catch (error) {
            logger.error('Error fetching tacho infringement report:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const updateTimesheetComments = async (timesheetId, comments) => {
        return await reportFunctions.updateTimesheetComments(timesheetId, comments);
    };

    // Trailer Location Report Function ============================================================================================
    const fetchTrailerLocation = async (trailerData) => {
        try {
            setIsLoading(true);
            resetReports();
            
            console.log("Fetching trailer location for:", trailerData);
            
            const sessionToken = await getSessionUUID();
            const response = await fetch(`/vehicles/trailer-location/${trailerData.id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionToken}`
                }
            });

            console.log("Response status:", response.status);
            console.log("Response ok:", response.ok);

            if (response.ok) {
                const result = await response.json();
                console.log("Trailer location data received:", result);
                setTrailerLocationData(result);
                setShowReport(true);
            } else {
                const errorResult = await response.json().catch(() => ({ error: `HTTP ${response.status} - ${response.statusText}` }));
                console.error("API Error Response:", errorResult);
                setTrailerLocationData({ error: errorResult.error || errorResult.message || `Server error: ${response.status}` });
                setShowReport(true);
            }
        } catch (error) {
            console.error("Network/Parse Error:", error);
            resetReports();
            showAlert({
                message: `Network error: ${error.message}. Please check your connection and try again.`,
                type: 'danger',
                buttons: [{ type: 'danger', label: 'Close' }],
            });
        } finally {
            setIsLoading(false);
        }
    };

    // Holidays Report Function ====================================================================================================
    const fetchHolidaysReport = async (data) => {
        try {
            setIsLoading(true);
            resetReports();
            
            const year = data.year;
            
            // Fetch holidays for the current year
            const holidaysRange = {
                from: `${year}-01-01`,
                to: `${year}-12-31`
            };
            
            let reportHolidays = [];
            
            // Use the holidays functions to fetch data
            await holidaysFunctions.fetchHolidays(
                (holidaysData) => { reportHolidays = holidaysData; },
                () => {},
                holidaysRange
            );
            
            // Debug logging
            console.log('Report Holidays:', reportHolidays);
            console.log('Drivers List:', driversList);
            console.log('Admin List:', adminList);
            
            // Set the data for the holidays report
            setHolidaysReportData({
                holidays: reportHolidays,
                users: { drivers: driversList, admins: adminList, warehouseStaff: warehouseStaff },
                year,
                driverId: data.driverId
            });
            
            setShowReport(true);
            
        } catch (error) {
            logger.error("Error fetching holidays report:", error);
            showAlert({
                message: 'Failed to fetch holidays report data',
                type: 'danger',
                buttons: [{ label: 'Close', type: 'primary' }]
            });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        console.log("DashboardReports MOUNTED");

        return () => {
            console.log("DashboardReports UNMOUNTED");
        };
    }, []);

    return (
        <div>
        {isLoading ? (
                    <div style={{ alignSelf: 'center', justifyContent: 'center', marginTop: '30vh' }}>
                        <ActivityIndicator />
                    </div>
            ) : (
        
        <div style={{ textAlign: 'center' }}>
            
            {!showReport ? (
                <>
                    <h3>Reports</h3>
                    <div
                        className="reports-container flex-container-with-dates"
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            gap: '1rem',
                            marginBottom: '20px',
                            position: 'relative',
                            zIndex: 1,
                            overflow: 'visible',
                        }}
                    >
                        {/* ── Routes & Deliveries ─────────────────────────── */}
                        {features?.routing !== false && isRoutingAllowed && (
                        <>
                        <div style={{ flex: '1 1 100%', borderBottom: `2px solid ${theme === 'dark' ? '#444' : '#ddd'}`, paddingBottom: '4px', marginBottom: '4px', textAlign: 'left' }}>
                            <span style={{ fontWeight: '700', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.06em', color: theme === 'dark' ? '#aaa' : '#666' }}>Routes &amp; Deliveries</span>
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectReports title={'Route Reports'} fetchReports={fetchReports} />
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectRouteReport fetchReports={fetchRouteReports} customers={customers} customerDeliveries={customerDeliveries} />
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectByRange fetchReports={fetchRoutesByRange} title={'Routes By Date'} list={uniqueCustomers} theme={theme} />
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectByRange fetchReports={fetchDriverRoutes} title={'Driver Route Report'} list={[...driversList, ...adminList]} theme={theme} />
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectByDateRange fetchReports={fetchSubcontractedRoutes} title={'Subcontracted Routes'} theme={theme} />
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectNetworkFreightReport fetchReports={fetchNetworkFreightReport} theme={theme} />
                        </div>
                        </>
                        )}

                        {/* ── Fleet & Vehicles ────────────────────────────── */}
                        {features?.service !== false && (isDev || permissions.perm_vehicles_view) && (
                        <>
                        <div style={{ flex: '1 1 100%', borderBottom: `2px solid ${theme === 'dark' ? '#444' : '#ddd'}`, paddingBottom: '4px', marginBottom: '4px', marginTop: '8px', textAlign: 'left' }}>
                            <span style={{ fontWeight: '700', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.06em', color: theme === 'dark' ? '#aaa' : '#666' }}>Fleet &amp; Vehicles</span>
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectReports title={'Vehicle Lease Report'} fetchReports={fetchVehicleLeaseReport} />
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectByDateRange fetchReports={fetchVehiclesRentalReport} title={'Vehicles Rental Report'} theme={theme} />
                        </div>
                        {features?.mobile !== false && (
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectTrailerLocation fetchReports={fetchTrailerLocation} allTrailers={allTrailers} theme={theme} />
                        </div>
                        )}
                        {(isDev || permissions.perm_defects_view) && (
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectByRange
                                fetchReports={fetchDriverVehicleChecks}
                                title={'Driver Vehicle Checks'}
                                list={[...driversList, ...adminList]}
                                theme={theme}
                            />
                        </div>
                        )}
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 10,
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: '20px auto',
                                padding: '40px',
                                width: '100%',
                                border: '2px solid',
                                borderRadius: '10px',
                                minHeight: '290px',
                            }}>
                                <h2>All Vehicles Audit</h2>
                                <p style={{ textAlign: 'center', fontSize: '14px', color: '#666' }}>
                                    VTG7, MOT, LOLER, brake tests &amp; service inspections for all active vehicles
                                </p>
                                <button
                                    onClick={downloadAllVehiclesAudit}
                                    disabled={isLoading}
                                    style={{
                                        padding: '10px 20px',
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '5px',
                                        cursor: isLoading ? 'not-allowed' : 'pointer',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        opacity: isLoading ? 0.7 : 1,
                                    }}
                                    onMouseOver={(e) => { if (!isLoading) e.target.style.backgroundColor = '#0056b3'; }}
                                    onMouseOut={(e) => { if (!isLoading) e.target.style.backgroundColor = '#007bff'; }}
                                >
                                    {isLoading ? 'Generating…' : 'Download Audit'}
                                </button>
                                <button
                                    onClick={downloadAllVehiclesFilesZip}
                                    disabled={isLoading || isFilesZipDownloading}
                                    style={{
                                        padding: '10px 20px',
                                        backgroundColor: '#28a745',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '5px',
                                        cursor: (isLoading || isFilesZipDownloading) ? 'not-allowed' : 'pointer',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        opacity: (isLoading || isFilesZipDownloading) ? 0.7 : 1,
                                    }}
                                    onMouseOver={(e) => { if (!isLoading && !isFilesZipDownloading) e.target.style.backgroundColor = '#1e7e34'; }}
                                    onMouseOut={(e) => { if (!isLoading && !isFilesZipDownloading) e.target.style.backgroundColor = '#28a745'; }}
                                >
                                    {isFilesZipDownloading ? 'Preparing Download...' : 'Download All Files'}
                                </button>
                                <ProgressTracker
                                    title="Vehicle Files Download"
                                    progress={filesZipProgress}
                                    status={filesZipStatus}
                                    isProcessing={isFilesZipDownloading}
                                    showProgress={true}
                                />
                            </div>
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 10,
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: '20px auto',
                                padding: '40px',
                                width: '100%',
                                border: '2px solid #dc3545',
                                borderRadius: '10px',
                                minHeight: '290px',
                            }}>
                                <h2 style={{ color: '#dc3545' }}>Missing Documents</h2>
                                <p style={{ textAlign: 'center', fontSize: '14px', color: '#666' }}>
                                    Audit all active vehicles for missing VTG7, MOT, LOLER, Tacho, brakes &amp; service records
                                </p>
                                <button
                                    onClick={downloadMissingDocsReport}
                                    disabled={isLoading}
                                    style={{
                                        padding: '10px 20px',
                                        backgroundColor: '#dc3545',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '5px',
                                        cursor: isLoading ? 'not-allowed' : 'pointer',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        opacity: isLoading ? 0.7 : 1,
                                    }}
                                    onMouseOver={(e) => { if (!isLoading) e.target.style.backgroundColor = '#a71d2a'; }}
                                    onMouseOut={(e) => { if (!isLoading) e.target.style.backgroundColor = '#dc3545'; }}
                                >
                                    {isLoading ? 'Generating…' : 'Download Report'}
                                </button>
                            </div>
                        </div>
                        </>
                        )}

                        {/* ── Warehouse ───────────────────────────────────── */}
                        {features?.warehouse !== false && (isDev || permissions.perm_warehouse_view) && (
                        <>
                        <div style={{ flex: '1 1 100%', borderBottom: `2px solid ${theme === 'dark' ? '#444' : '#ddd'}`, paddingBottom: '4px', marginBottom: '4px', marginTop: '8px', textAlign: 'left' }}>
                            <span style={{ fontWeight: '700', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.06em', color: theme === 'dark' ? '#aaa' : '#666' }}>Warehouse</span>
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <WeeklyStorageReport fetchReports={fetchWeeklyStorageReport} customers={customers} />
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectCustomerSnapShot fetchReports={fetchSnapShot} customers={customers} theme={theme} />
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectByDateRange fetchReports={fetchInboundReports} title={'Inbound Reports'} theme={theme} />
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectByDateRange fetchReports={fetchDispatchReports} title={'Dispatch Reports'} theme={theme} />
                        </div>
                        </>
                        )}

                        {/* ── Purchase Orders ─────────────────────────────── */}
                        {features?.purchase_orders === true && isPurchaseOrdersAllowed && (
                        <>
                        <div style={{ flex: '1 1 100%', borderBottom: `2px solid ${theme === 'dark' ? '#444' : '#ddd'}`, paddingBottom: '4px', marginBottom: '4px', marginTop: '8px', textAlign: 'left' }}>
                            <span style={{ fontWeight: '700', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.06em', color: theme === 'dark' ? '#aaa' : '#666' }}>Purchase Orders</span>
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectPONumberReport fetchReports={fetchPOByNumber} theme={theme} />
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectByDateRange fetchReports={fetchPOByDateRange} title={'PO Date Range Report'} theme={theme} />
                        </div>
                        </>
                        )}

                        {/* ── HR & Timesheets ─────────────────────────────── */}
                        {((features?.timesheets !== false && isTimesheetsAllowed) || (features?.holidays !== false && isHolidaysAllowed)) && (
                        <>
                        <div style={{ flex: '1 1 100%', borderBottom: `2px solid ${theme === 'dark' ? '#444' : '#ddd'}`, paddingBottom: '4px', marginBottom: '4px', marginTop: '8px', textAlign: 'left' }}>
                            <span style={{ fontWeight: '700', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.06em', color: theme === 'dark' ? '#aaa' : '#666' }}>HR &amp; Timesheets</span>
                        </div>
                        {features?.holidays !== false && isHolidaysAllowed && (
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectHolidaysReport
                                fetchReports={fetchHolidaysReport}
                                drivers={driversList}
                                theme={theme}
                            />
                        </div>
                        )}
                        {features?.timesheets !== false && isTimesheetsAllowed && (
                        <>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectByDateRange fetchReports={fetchClockInOutReport} title={'Clock In/Out Report'} theme={theme} />
                        </div>
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectSingleDate fetchReports={fetchTimeSheetReport} title={'Time Sheet Report'} theme={theme} />
                        </div>
                        </>
                        )}
                        </>
                        )}

                        {/* ── Compliance ──────────────────────────────────── */}
                        {((features?.alcohol_testing !== false && isAlcoholAllowed) || (features?.tacho !== false && isTachoAllowed) || features?.fire_register !== false) && (
                        <>
                        <div style={{ flex: '1 1 100%', borderBottom: `2px solid ${theme === 'dark' ? '#444' : '#ddd'}`, paddingBottom: '4px', marginBottom: '4px', marginTop: '8px', textAlign: 'left' }}>
                            <span style={{ fontWeight: '700', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.06em', color: theme === 'dark' ? '#aaa' : '#666' }}>Compliance</span>
                        </div>
                        {features?.alcohol_testing !== false && isAlcoholAllowed && (
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectByDateRange fetchReports={fetchAlcoholTestingReport} title={'Alcohol Testing Report'} theme={theme} />
                        </div>
                        )}
                        {features?.tacho !== false && isTachoAllowed && (
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectByDateRange fetchReports={fetchTachoInfringementReport} title={'Tacho Infringement Report'} theme={theme} />
                        </div>
                        )}
                        {features?.fire_register !== false && (
                        <div style={{ flex: '1 1 30%', maxWidth: '30%' }}>
                            <SelectByDateRange fetchReports={fetchFireRegisterReport} title={'Fire Register Report'} theme={theme} />
                        </div>
                        )}
                        </>
                        )}
                    </div>
                </>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                    <h3>Report Data</h3>

                    <FontAwesomeIcon
                        icon={faArrowsRotate}
                        style={{ cursor: 'pointer', marginBottom: '10px', marginLeft: '20px', width: '25px', height: '25px', color: theme === 'dark' ? '#ccc' : '#000' }}
                        onClick={() => {
                            resetReports();
                        }}
                    />
                </div>
            )}        
            

            {/* Render Report Data */}
            {showReport && (
                (monthlyReportData && monthlyReportData.length > 0) ? (
                    <WeeklyReport
                        jobs={monthlyReportData}
                        theme={theme}
                    />
                ) : (reportTableData && reportTableData.length) > 0 ? (
                    <RouteReports
                        routeData={reportTableData}
                        theme={theme}
                    />
                ) : (driverRoutesData && driverRoutesData.length > 0) ? (
                    <DriverRoutesReport
                        routeData={driverRoutesData}
                        theme={theme}
                    />
                ) : (fireRegisterReportData && fireRegisterReportData.length > 0) ? (
                    <FireRegisterReport
                        registerData={fireRegisterReportData}
                        theme={theme}
                    />
                ) : (weeklyStorageData && weeklyStorageData.length > 0) ? (
                    <WeeklyStorageReportDisplay
                        storageData={weeklyStorageData}
                        customers={customers}
                        theme={theme}
                    />
                ) : (snapShotData && (snapShotData.snapshot_data || snapShotData.summary)) ? (
                    <WarehouseSnapshotReport
                        snapData={snapShotData}
                        customers={customers}
                        theme={theme}
                    />
                ) : (trailerLocationData) ? (
                    <TrailerLocationReport
                        locationData={trailerLocationData}
                        theme={theme}
                    />
                ) : (purchaseOrdersReportData && purchaseOrdersReportData.length > 0) ? (
                    <PurchaseOrdersReport
                        reportData={purchaseOrdersReportData}
                        theme={theme}
                    />
                ) : (holidaysReportData && holidaysReportData.holidays && holidaysReportData.users) ? (
                    <HolidaysReport
                        holidaysData={holidaysReportData.holidays}
                        usersData={holidaysReportData.users}
                        selectedYear={holidaysReportData.year}
                        selectedDriverId={holidaysReportData.driverId}
                        theme={theme}
                    />
                ) : (inboundReportsData && inboundReportsData.length > 0) ? (
                    <InboundReport
                        inboundData={inboundReportsData}
                        theme={theme}
                    />
                ) : activeVehiclesReportRequested ? (
                    <ActiveVehiclesReport
                        activeVehiclesData={activeVehiclesData}
                        theme={theme}
                    />
                ) : (dispatchReportsData && dispatchReportsData.length > 0) ? (
                    <DispatchReport
                        dispatchData={dispatchReportsData}
                        theme={theme}
                    />
                ) : (subcontractedRoutesData && subcontractedRoutesData.length > 0) ? (
                    <SubcontractedRoutesReport
                        subcontractedData={subcontractedRoutesData}
                        theme={theme}
                    />
                ) : (clockInOutReportData && clockInOutReportData.length > 0) ? (
                    <ClockInOutReport
                        clockEventsData={clockInOutReportData}
                        theme={theme}
                    />
                ) : (timeSheetReportData && timeSheetReportData.length > 0) ? (
                    <TimeSheetReport
                        timesheetData={timeSheetReportData}
                        theme={theme}
                        onUpdateComments={updateTimesheetComments}
                    />
                ) : (alcoholTestingReportData && alcoholTestingReportData.length > 0) ? (
                    <AlcoholTestingReport 
                        testData={alcoholTestingReportData}
                        theme={theme} 
                    />
                ) : (tachoInfringementReportData && tachoInfringementReportData.length > 0) ? (
                    <TachoInfringementReport
                        infringementData={tachoInfringementReportData}
                        theme={theme}
                    />
                ) : (routesByDateData && routesByDateData.length > 0) ? (
                    <RouteReports
                        routeData={routesByDateData}
                        theme={theme}
                    />
                ) : networkFreightReportData !== null ? (
                    <NetworkFreightConsignmentReport
                        routes={networkFreightReportData}
                        theme={theme}
                    />
                ) : driverVehicleChecksData !== null ? (
                    <VehicleChecksDisplay
                        checks={driverVehicleChecksData}
                        theme={theme}
                    />
                ) : (
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <p>No report data available.</p>
                    </div>
                )
            )}
        </div>
    )}
    </div>
    )
};

export default DashboardReports;